module.exports = __webpack_public_path__ + "2ed1e3c751a14c008f7951b176f0937c.gif";